// Shared styling/behaviour helpers for the filter drawers used across
// delivery-related pages (RecordsFilters, IssueFilters) so both stay visually
// and behaviourally consistent without duplicating the same snippets.

export function toggle(arr, value) {
  return arr.includes(value) ? arr.filter((v) => v !== value) : [...arr, value];
}

export function chipStyle(active) {
  return {
    borderRadius: 8,
    boxShadow: "none",
    borderColor: active ? "#BFDBFE" : "#E2E8F0",
    background: active ? "#EFF6FF" : "#fff",
    color: active ? "#1D4ED8" : "#64748B",
    fontWeight: 500,
  };
}

export const sectionLabelStyle = {
  fontWeight: 600,
  marginBottom: 8,
  color: "#374151",
  display: "block",
};
